// status-acronym-tooltip.component.ts
import { Component, Input, OnInit } from '@angular/core';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'status-acronym-tooltip',
  templateUrl: './status-acronym-tooltip.component.html',
  styleUrls: ['./status-acronym-tooltip.component.css']
})
export class StatusAcronymTooltipComponent implements OnInit {
  @Input() acronymList: any[];

  constructor(private logger: LogService) { }

  ngOnInit(): void {
    this.logger.trackEvent('TankGrid', 'Column', 'StatusAcronymTooltipRollover');
  }
}
